
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-armenia/[slug]",
      function () {
        return require("private-next-pages/about-armenia/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-armenia/[slug]"])
      });
    }
  